export function uuid () {
    let dt = new Date().getTime()
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (dt + Math.random() * 16) % 16 | 0
        dt = Math.floor(dt / 16)
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
}

const TRANSLATION_TEXTS = {
    "fr" : {
        ARTICULATION_LEFT_KNEE: "Genou gauche",
        ARTICULATION_RIGHT_KNEE: "Genou droit",
        ARTICULATION_BOTH_KNEE: "Les deux genoux",
        //ARTICULATION_LEFT_HIP: "Hanche gauche",
        //ARTICULATION_RIGHT_HIP: "Hanche droite",
        ARTICULATION_UPPER_LIMB: "Membre supérieur",

        DISEASE_DIABETES: "Diabète",
        DISEASE_HYPERTENSION: "Hypertension",
        DISEASE_CHOLESTEROL: "Hypercholestérolémie",
        DISEASE_ARTHRITIS: "Polyarthrite",
        DISEASE_FIBRILLATION: "Trouble du rythme cardiaque (Fibrillation, autre)",
        DISEASE_COAGULATION_DISORDER: "Trouble de la coagulation",
        DISEASE_NONE: "Aucune",

        SINCE_ACCIDENT: "Depuis l’accident",
        SINCE_LESS_THAN_A_MONTH: "Depuis moins de 1 mois",
        SINCE_MORE_THAN_A_MONTH: "Depuis plus de 1 mois",
        SINCE_SIX_MONTH: "Depuis plus que 6 mois",
        SINCE_ONE_YEAR: "Depuis plus que 1 an",
        SINCE_TWO_YEARS: "Depuis plus que 2 ans",
        SINCE_FIVE_YEARS: "Depuis plus que 5 ans",
        SINCE_TEN_YEARS: "Depuis plus que 10 ans",

        male: "Homme",
        female: "Femme",
        undefined: "Indéfini",
        other: "Autre",

        TREATMENT_FULL_KNEE_REPLACEMENT: "Prothèse totale du genou",
        TREATMENT_PARTIAL_KNEE_REPLACEMENT: "Prothèse partielle du genou",
        TREATMENT_REVISION_KNEE_ARTHROPLASTY: "Changement de prothèse",
        //TREATMENT_FULL_HIP_REPLACEMENT: "Prothèse de la hanche",
        TREATMENT_SURGERY: "Chirurgie",
        TREATMENT_PHYSIO: "Physio",
        TREATMENT_OSTEO: "Ostéopathie",
        TREATMENT_INF_CORTISONE: "Infiltration de Cortisone",
        TREATMENT_INF_ACIDE_HYALURONIQUE: "Infiltration d'acide hyaluronique",
        TREATMENT_OTHER: "Autre traitement",

        REVISION_INFECTION: "Infection",
        REVISION_DESCELLEMENT: "Descellement",
        REVISION_INSTABILITY: "Instabilité",
        REVISION_PAIN: "Douleurs",
        REVISION_RESURFACAGE: "Resurfaçage rotule",
        REVISION_RAIDEUR: "Raideur articulaire",
        REVISION_MALTRACKING: "Maltracking rotule",
        REVISION_DEFAULT_AXE_HKA: "Défaut axe HKA",

        PTG_STANDARD: "PTG Standard",
        PTG_MAKO: "PTG MAKO",
        PTG_MYKNEE: "PTG Myknee",
        PTG_NEXT_AR: "PTG Next AR",
        PTG_SYMBIOS: "PTG Symbios sur mesure",
        PUC_STANDARD: "PUC Standard",
        PUC_NEXT_AR: "PUC Next AR",
        PUC_SYMBIOS: "PUC Symbios sur mesure",
        PTG_UPDATE: "Changement PTG",
        PUC: "PUC",
        PUC_MAKO: "PUC MAKO",
        PUC_MYKNEE: "PUC Myknee",
        PUC_UPDATE: "Changement PUC",

        RIGHT: "Droit",
        LEFT: "Gauche",
        BOTH: "Les deux",
        NONE: "Aucun",

        DIAGNOSTIC_GONARTHROSE: "Gonarthrose",
        //DIAGNOSTIC_ARTHROSE_HANCHE: "Arthrose de hanche",
        DIAGNOSTIC_LCA: "Rupture LCA",
        DIAGNOSTIC_LCP: "Rupture LCP",
        DIAGNOSTIC_LPI: "Lésion plan interne (LLI, POL)",
        DIAGNOSTIC_LPE: "Lésion plan externe (LLE, poplité, PFL)",
        DIAGNOSTIC_LM: "Lésions méniscales",
        DIAGNOSTIC_CARTI_NON_DEG: "Lésions cartilagineuses non dégénératives",
        DIAGNOSTIC_ROTULE: "Instabilité rotule",
        DIAGNOSTIC_LESION_CARTI_ROTULE: "Lésion cartilage rotule/trochlée",
        DIAGNOSTIC_PTG_DOULOUREUSE: "PTG douloureuse",
        DIAGNOSTIC_OTHER: "Autres",

        FOLLOW_UP_STATUS_SKIP: "Passé",
        FOLLOW_UP_STATUS_COMPLETED: "Terminé",
        FOLLOW_UP_STATUS_UNCOMPLETED: "En cours",
        FOLLOW_UP_STATUS_NEXT: "Prévu",

        doctor: "Via médecin",
        physio: "Via physio",
        internet: "Via internet",
        reception: "Via réception de La Tour",
        emergencies: "Via urgences de La Tour",
        person_advise: "Via conseil d’une personne",
        dont_know: "Ne sait pas",

        desk: "Bureau",
        admin_manual: "Administratif et Manuel",
        manual_light: "Manuel léger",
        manual_heavy: "Manuel lourd",
        unemployed: "Sans emploi",
        retired: "Retraité",
        housewife: "Personne au foyer",
        sport_pro: "Sportif Professionnel",

        ARTHROSIS_0: "Aucune arthrose",
        ARTHROSIS_1: "Arthrose débutante",
        ARTHROSIS_2: "Arthrose modérée",
        ARTHROSIS_3: "Arthrose avancée",
        ARTHROSIS_4: "Arthrose sévère",

        SLOPE_BEFORE: "Pente antérieure",

        HKA_ANGLE: "HKA angle",
        LDFA_ANGLE: "LDFA angle",
        MPTA_ANGLE: "MPTA angle",
        pre:"Pré-opératoire",
        post:"Post-opératoire",

        DEATH: "Décès",
        PATIENT_WITHDRAWAL: "Patient souhaite arrêter le suivi",
        DOCTOR_WITHDRAWAL: "Médecin souhaite arrêter le suivi",
        OTHER: "Autre",
        PAUSED: "En pause",
    }
}
export function getTranslationString(key, lang = "fr") {
    return TRANSLATION_TEXTS[lang][key]
}

export function formatDate (date) {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
}
